module.exports = __webpack_public_path__ + "static/img/patho-foreign-body-item-BKzFa8S5.aac45ebe.png";